import React, { FunctionComponent, useContext, useEffect } from 'react'
import { Button, Result } from 'antd'
import CenteredPage from '../../views/styled/CenteredPage/CenteredPage'
import { useRouter, useSearch } from '@tanstack/react-router'
import { AppContext } from '../../contexts/AppContext'
import AppContextInterface from '../../contexts/AppContext/AppContextInterface'

interface IProps {
  error: any
  reset: any
}

const ErrorComponent: FunctionComponent<any> = (props: IProps) => {

  const { error } = props

  const router = useRouter()
  const search = useSearch({
    strict: false,
  })

  const { logSplunk } = useContext(AppContext) as AppContextInterface

  useEffect(() => {
    logSplunk(error)
  }, [error, logSplunk])

  return (
    <CenteredPage>
      <Result
        status={'error'}
        title={'Error'}
        subTitle={error.message}
        extra={
          <Button
            onClick={() => {
              // reset()
              router.navigate({ search })
            }}
          >
            Reload
          </Button>
        }
      />
    </CenteredPage>
  )
}

export default ErrorComponent
